<template>
  <canvas id="chart" ref="myChart"></canvas>
</template>

<script>
import Chart from 'chart.js';

export default {
  // camel case not kebab case
  name: 'statsPieChart',
  props: {
    labels: {
      required: true,
    },
    datasets: {
      required: true,
    },
    isMcqImage: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      imageURLs: [
        'https://s3.eu-west-3.amazonaws.com/explorama-dev/contentPictures/e48e984b-9bb4-45fd-b3bf-d7c66e580fa7-arbre.jpg',
        'https://s3.eu-west-3.amazonaws.com/explorama-dev/contentPictures/3d44eb59-efff-4288-a226-95b2216d2d2f-statue.jpg',
        'https://i.stack.imgur.com/3KRtW.png',
        'https://i.stack.imgur.com/iLyVi.png',
      ],
      ctx: '',
    };
  },
  watch: {
    datasets(newDatasets) {
      this.chart.data.datasets = newDatasets;
      if (this.isMcqImage) {
        setTimeout(this.updateDatasets(), 3000);
      }
      this.chart.update();
    },
    labels(newLabels) {
      this.chart.data.labels = newLabels;
      this.chart.update();
    },
  },
  methods: {
    updateDatasets() {
      let ctx = document.getElementById('chart').getContext('2d');
      let paterns = this.labels.map((url) => {
        let img = new Image();
        img.src = url;
        let p = ctx.createPattern(img, 'repeat-y');
        return p;
      });
      this.datasets[0].backgroundColor = paterns;
    },
  },
  computed: {
    images() {
      const images = this.imageURLs.map((v) => {
        var image = new Image();
        image.src = v;
        return image;
      });
      return images;
    },
  },
  mounted() {
    this.chart = new Chart(this.$refs.myChart, {
      type: 'pie',
      data: {
        labels: this.labels,
        datasets: this.datasets,
      },
      // plugins: [{
      //   afterDatasetsDraw: chart => {
      //     var ctx = chart.ctx;
      //     ctx.save();
      //     var xCenter = chart.canvas.width / 2;
      //     var yCenter = chart.canvas.height / 2;
      //     var data = chart.config.data.datasets[0].data;
      //     var vTotal = data.reduce((a, b) => a + b, 0);
      //     data.forEach((v, i) => {
      //       console.log('vDATAforeach:', v)
      //       var vAngle = data.slice(0, i).reduce((a, b) => a + b, 0) + v / 2;
      //       var angle = 360 / vTotal * vAngle - 90;
      //       var radians = angle * (Math.PI / 180);
      //       var r = yCenter;
      //       var x = xCenter + Math.cos(radians) * r / 2;
      //       var y = yCenter + Math.sin(radians) * r / 2;
      //       ctx.translate(x, y);
      //       var image = this.images[i];
      //       ctx.drawImage(image, -image.width / 2, -image.height / 2, image.width/4, image.height/4);
      //       ctx.translate(-x, -y);
      //     });
      //     ctx.restore();
      //   }
      // }],
      options: {
        cutoutPercentage: 30,
        legend: {
          onClick: false,
          position: 'bottom',
          align: 'start',
          labels: {
            boxWidth: 25,
            fontSize: 12,
            padding: 5,
          },
        },
        tooltips: {
          backgroundColor: '#AEACAC',
          bodyFontSize: 13,
          callbacks: {
            // eslint-disable-next-line
            label: function (tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];
              // eslint-disable-next-line
              var total = dataset.data.reduce(function (
                previousValue,
                currentValue,
                currentIndex,
                array
              ) {
                return parseInt(previousValue) + parseInt(currentValue);
              });
              var currentValue = dataset.data[tooltipItem.index];
              var percentage = Math.floor((currentValue / total) * 100 + 0.5);
              return percentage + '%';
            },
          },
        },
      },
    });

    if (this.isMcqImage) {
      setTimeout(this.updateDatasets(), 1000);
      this.chart.update();
    }

    // let img = new Image(100, 100);
    // img.src= "https://s3.eu-west-3.amazonaws.com/explorama-dev/contentPictures/e48e984b-9bb4-45fd-b3bf-d7c66e580fa7-arbre.jpg";

    // console.log("image", img)
    // let ctx = document.getElementById('chart').getContext('2d')
    // console.log("ctx: ", ctx)
    // this.ctx = ctx;
    // let patern = ctx.createPattern(img, 'repeat');

    // this.datasets[0].backgroundColor = [patern,patern,patern,patern]
    // this.chart.data.datasets = this.datasets
    // this.chart.update();
  },
};
</script>
<style lang="sass"></style>
